
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
/* Apply component specific CSS */
.breadcrumbs {

    margin-right: 0.75rem;

    align-items: center;

    gap: 0.5rem
}

@media (min-width: 768px) {

    .breadcrumbs {

        display: flex
    }
}

.breadcrumbs span {

    display: none;

    align-items: center;

    gap: 0.5rem
}

@media (min-width: 768px) {

    .breadcrumbs span {

        display: inline-flex
    }
}

.breadcrumbs span:nth-last-of-type(2) {

    display: inline-flex
}

.breadcrumbs a, .breadcrumbs span {

    text-decoration-line: none
}

.breadcrumbs a:hover {

    text-decoration-line: underline
}

.separator {

    display: none
}

@media (min-width: 768px) {

    .separator {

        display: block
    }
}

.separator--back {

    display: block
}

@media (min-width: 768px) {

    .separator--back {

        display: none
    }
}

.return-link span:first-child {

    display: inline-flex
}

:host([site='GHS']) .breadcrumbs a, :host([site='GHS']) .breadcrumbs span {

    font-family: var(--ff-display)
}

:host([site='GHS']) .breadcrumbs a, :host([site='GHS']) .breadcrumbs span {

    font-size: var(--fs-sm);

    line-height: var(--lh-sm)
}

:host([site='GHS']) .breadcrumbs a, :host([site='GHS']) .breadcrumbs span {

    font-weight: var(--fw-medium)
}

:host([site='GHS']) .breadcrumbs a, :host([site='GHS']) .breadcrumbs span {

    color: var(--neutral-white)
}

:host([site='GHS']) .breadcrumbs span:last-of-type {

    font-weight: var(--fw-semibold)
}

:host([site='GHS']) .breadcrumbs span:nth-last-of-type(2) a {

    font-weight: var(--fw-semibold)
}

@media (min-width: 768px) {

    :host([site='GHS']) .breadcrumbs span:nth-last-of-type(2) a {

        font-weight: var(--fw-medium)
    }
}

:host([site='GHS']) .return-link span:first-child a {

    font-weight: var(--fw-semibold)
}

:host([site='GHS']) .background-light a, :host([site='GHS']) .background-light span {

    color: var(--primary-blue-light-2)
}

:host([site='GHS']) .background-light ghs-icon {

    color: var(--primary-blue-light-2)
}

:host([site='BH']) a, :host([site='BH']) span, :host([site='BH']) ghs-icon {

    color: var(--bh-brand-primary-default)
}

:host([site='BH']) .ghs-breadcrumbs__separator {

    color: var(--bh-neutral-dark)
}

:host([site='BH']) .breadcrumbs a, :host([site='BH']) .breadcrumbs span {

    font-family: var(--bh-ff-body)
}

:host([site='BH']) .breadcrumbs a, :host([site='BH']) .breadcrumbs span {

    font-size: var(--bh-fs-body-01);

    line-height: var(--bh-lh-body-01);

    letter-spacing: var(--bh-ls-body-01)
}

:host([site='BH']) .breadcrumbs span:last-of-type {

    color: var(--bh-neutral-darker)
}

:host([site='BH']) a {

    display: contents
}

:host([site='BH']) a > ghs-icon {

    display: none
}

@media (min-width: 768px) {

    :host([site='BH']) a > ghs-icon {

        display: block
    }
}
`;